import * as React from "react";
import { styled } from "@mui/material/styles";
import {
  Box,
  CircularProgress,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Toolbar,
  Typography,
} from "@mui/material";
import { tableCellClasses } from "@mui/material/TableCell";

import { colors } from "../pages/css components/Style";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: colors.hoverBlue,
    color: colors.sprintexBlue,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
    color: colors.text,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  ".MuiTableCell-root": {
    border: "none",
    padding: "10px",
  },

  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

export default function MuiTable({
  loading,
  components = [],
  columns,
  data,
  renderCell,
  ...props
}) {
  return components.length > 0 ? (
    <Paper>
      <Toolbar style={{ padding: "10px" }}>
        {components.map((com) => com)}
      </Toolbar>
      <RenderedTable />
    </Paper>
  ) : (
    <RenderedTable />
  );

  function RenderedTable() {
    return (
      <TableContainer sx={{ borderRadius: "0 0" }} component={Paper}>
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead style={{ height: "45px" }}>
            <TableRow>
              {columns.map((col, index) => (
                <StyledTableCell key={index}>{col.label}</StyledTableCell>
              ))}
            </TableRow>
          </TableHead>

          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={columns.length} sx={{ padding: 0 }}>
                  <Box
                    sx={{
                      height: "300px",
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <CircularProgress
                      thickness={4}
                      size={40}
                      sx={{ color: colors.sprintexBlue, mb: 2 }}
                    />
                    <Typography
                      variant="h6"
                      sx={{ color: colors.sprintexBlue }}
                    >
                      Fetching data...
                    </Typography>
                  </Box>
                </TableCell>
              </TableRow>
            ) : data.length > 0 ? (
              data.map((row, rowIdx) => (
                <StyledTableRow key={rowIdx}>
                  {columns.map((col, colIdx) => (
                    <StyledTableCell component="th" scope="row" key={colIdx}>
                      {renderCell
                        ? renderCell(col, row[col.name], row)
                        : row[col.name]}
                    </StyledTableCell>
                  ))}
                </StyledTableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={columns.length} sx={{ padding: 0 }}>
                  <Box
                    sx={{
                      height: "300px", // height of the area where you want it centered
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      variant="h6"
                      sx={{ color: colors.sprintexBlue }}
                    >
                      No Data Found
                    </Typography>
                  </Box>
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    );
  }
}
